import { useTranslations } from "next-intl";

export default function NormalizedSize({
  size,
  normalizedSize,
}: {
  size: string;
  normalizedSize: string;
}) {
  const t = useTranslations("normalized-size");

  if (size && normalizedSize && size !== normalizedSize) {
    return (
      <div className="text-[16px] max-md:text-[14px] px-[16px] border border-secondary-sunflower rounded-[20px] bg-secondary-sunflower/20 text-center py-[14px]">
        {t.rich("message-long", {
          size,
          strong: (chunks) => <strong className="font-bold">{chunks}</strong>,
        })}
      </div>
    );
  }

  return <></>;
}
